import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

interface Props {
  name?: string | null;
  url?: string | null;
  address?: string | null;
  phones?: any[];
  workingHours?: any[];
  isActive?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCentersListItem',
  props: {
    name: { default: null },
    url: { default: null },
    address: { default: null },
    phones: { default: () => [] },
    workingHours: { default: () => [] },
    isActive: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { name: string | null, url: string | null, address: string | null, phones: any[], workingHours: any[], isActive: boolean };



const serviceElement = ref();
const formatTime = (time: any, index: number) => {
  return `${index > 0 ? '-' : ''} ${time.start}-${time.end}`;
};

watch(
  () => props.isActive,
  (value) => {
    if (!value) return;
    serviceElement.value.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  },
);

return { __sfc: true,props, serviceElement, formatTime }
}

})